import { AddressResponse } from "../address-data-types";
import { request } from "../api-client";

export async function getAddressData(postcode: string): Promise<AddressResponse> {
  return request<AddressResponse>({
    url: `${import.meta.env.VITE_LOOKUP_URL}${postcode}`,
    method: "GET"
  });
}